import React from "react";
import { Link } from "react-router-dom";

export default function Student911TopMenu({ slug, activeMenu }) {
  console.log("slug", slug);

  return (
    <div className="breadcrumb-bar breadcrumb-bar-info mb-2 sticky-top">
      <div className="container-fluid text-center">
        <div className="d-flex justify-content-between flex-wrap">
          <div>
            <h6>Planning Room</h6>
            <div className="row text-center">
              <div className="d-flex justify-content-between">
                
                <div>
                  <Link
                    to={`/instructor/instructor-studenttask/${slug}`}
                    className={
                      activeMenu === "Task"
                        ? "tag text-decoration-underline text-info"
                        : "tag"
                    }
                  >
                    Agenda
                  </Link>
                </div>
                <div>
                  <Link
                    to={`/instructor/instructor-studentschedule/${slug}`}
                    className={
                      activeMenu === "CollegeVisit"
                        ? "tag text-decoration-underline text-info"
                        : "tag"
                    }
                  >
                    Schedule
                  </Link>
                </div>
                <div>
                  <Link
                    to={`/instructor/instructor-studentpersonalquestion/${slug}`}
                    className={
                      activeMenu === "PersonalQuestions"
                        ? "tag text-decoration-underline text-info"
                        : "tag"
                    }
                  >
                    Career
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div>
            <h6>Academics</h6>
            <div className="row">
              <div className="d-flex justify-content-between">
              <div>
                  <Link
                    to={`/instructor/instructor-studentgradelist/${slug}`}
                    className={
                      activeMenu === "GradeList"
                        ? "tag text-decoration-underline text-info"
                        : "tag"
                    }
                  >
                    Grades
                  </Link>
                </div>
                <div>
                  <Link
                    to={`/instructor/instructor-studentlesson/${slug}`}
                    className={
                      activeMenu === "Lessons"
                        ? "tag text-decoration-underline text-info"
                        : "tag"
                    }
                  >
                    Courses
                  </Link>
                </div>
              <div>
                <Link
                  to={`/instructor/instructor-academicassessment/${slug}`}
                  className={
                    activeMenu === "GoalGrades"
                      ? "tag text-decoration-underline text-info"
                      : "tag"
                  }
                >
                  SAT
                </Link>
              </div>
                {/* <div>
                  <Link
                    to={`/instructor/instructor-academicassessment/${slug}`}
                    className={
                      activeMenu === "Academic"
                        ? "tag text-decoration-underline text-info"
                        : "tag"
                    }
                  >
                    Assessments
                  </Link>
                </div> */}
               
                 {/*}
                <div>
                  <Link
                    to={`/instructor/instructor-studenttranskript/${slug}`}
                    className={
                      activeMenu === "Transkript"
                        ? "tag text-decoration-underline text-info"
                        : "tag"
                    }
                  >
                    Transcript
                  </Link>
                </div>
               
                                <div>
                                    <Link to={`/instructor/instructor-studentsat/${slug}`}
                                        className={
                                            activeMenu === "Sat"
                                                ? "tag text-decoration-underline text-info"
                                                : "tag"
                                        }>SAT</Link>
                                </div>

                                <div>
                                    <Link  to={`/instructor/instructor-studentcollegecourses/${slug}`}
                                        className={
                                            activeMenu === "CollegeCourses"
                                                ? "tag text-decoration-underline text-info"
                                                : "tag"
                                        }>College Courses</Link>                                    
                                </div>
                                */}
                <div>
                  <Link
                    to={`/instructor/instructor-studentbooklist/${slug}`}
                    className={
                      activeMenu === "BookList"
                        ? "tag text-decoration-underline text-info"
                        : "tag"
                    }
                  >
                    Readings
                  </Link>
                </div>
               
                {/* <div>
                  <Link
                    to={`/instructor/instructor-studentcoursesreport/${slug}`}
                    className={
                      activeMenu === "CoursesReports"
                        ? "tag text-decoration-underline text-info"
                        : "tag"
                    }
                  >
                    Courses Report
                  </Link>
                </div> */}
              </div>
            </div>
          </div>

          <div>
            <h6>Activities & Awards</h6>
            <div className="row">
              <div className="d-flex justify-content-between">
                <div>
                  <Link
                    to={`/instructor/instructor-studentactivty/${slug}`}
                    className={
                      activeMenu === "Activity"
                        ? "tag text-decoration-underline text-info"
                        : "tag"
                    }
                  >
                    Activities
                  </Link>
                </div>
                <div>
                  <Link
                    to={`/instructor/instructor-studentawards/${slug}`}
                    className={
                      activeMenu === "Awards"
                        ? "tag text-decoration-underline text-info"
                        : "tag"
                    }
                  >
                    Awards
                  </Link>
                </div>

                {/*}
                                <div>
                                    <Link to={`/instructor/instructor-studentprojects/${slug}`}
                                        className={
                                            activeMenu === "Projects"
                                                ? "tag text-decoration-underline text-info"
                                                : "tag"
                                        }>Projects</Link>
                                </div>   
                                */}
              </div>
            </div>
          </div>
          {/*}
                    <div>
                        <h6>More</h6>
                        <div className="row text-center">
                            <div className="d-flex justify-content-between">
                                <div>
                                    <Link to={`/instructor/instructor-studentbooklist/${slug}`}
                                        className={
                                            activeMenu === "BookList"
                                                ? "tag text-decoration-underline text-info"
                                                : "tag"
                                        }
                                    >Readings</Link>
                                </div>
                                <div>
                                    <Link to={`/instructor/instructor-studentcollegevisit/${slug}`}
                                        className={
                                            activeMenu === "CollegeVisit"
                                                ? "tag text-decoration-underline text-info"
                                                : "tag"
                                        }>College Visits</Link>
                                </div>
                                <div>
                                    <Link to={`/instructor/instructor-studentcalendar/${slug}`}
                                        className={
                                            activeMenu === "Calendar"
                                                ? "tag text-decoration-underline text-info"
                                                : "tag"
                                        }>Calendar</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    */}
          {/* <div>
            <h6>Career Planing</h6>
            <div className="d-flex justify-content-between">
              <div>
                <Link
                  to={`/instructor/instructor-studentgoalgrades/${slug}`}
                  className={
                    activeMenu === "GoalGrades"
                      ? "tag text-decoration-underline text-info"
                      : "tag"
                  }
                >
                  Goal Settings
                </Link>
              </div>
              <div>
                <Link
                  to={`/instructor/instructor-studentprogresscheck/${slug}`}
                  className={
                    activeMenu === "StundentProgressCheck"
                      ? "tag text-decoration-underline text-info"
                      : "tag"
                  }
                >
                  Progress Check
                </Link>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
}
